//"StatusId	StatusDescription	ForeColor	BackColor

export const statusesArray = [
    [
        "0",
        "Noise",
        "Black",
        "Silver"
    ],
    [
        "1",
        "New Booking",
        "Green",
        "White"
    ],
    [
        "2",
        "Failed Pending Retry",
        "Red",
        "White"
    ],
    [
        "3",
        "New Quote",
        "Blue",
        "White"
    ],
    [
        "4",
        "New Failed",
        "Red",
        "White"
    ],
    [
        "5",
        "Awaiting Requisition",
        "Green",
        "192,255,255"
    ],
    [
        "6",
        "Unallocated",
        "Green",
        "192,255,255"
    ],
    [
        "7",
        "Allocated",
        "Green",
        "192,255,255"
    ],
    [
        "8",
        "In Progress",
        "Green",
        "192,255,255"
    ],
    [
        "9",
        "Pulled for Parts - Awaiting Parts",
        "Green",
        "192,255,255"
    ],
    [
        "10",
        "Completed",
        "Green",
        "192,255,192"
    ],
    [
        "11",
        "Cancelled Booking",
        "Green",
        "192,192,255"
    ],
    [
        "12",
        "Cancelled Quote",
        "Blue",
        "192,192,255"
    ],
    [
        "13",
        "Failed Booking",
        "Red",
        "255,192,192"
    ],
    [
        "14",
        "Failed Quote",
        "Blue",
        "255,192,192"
    ],
    [
        "15",
        "In Debt",
        "Green",
        "255,192,255"
    ],
    [
        "16",
        "Written Off",
        "Green",
        "255,192,255"
    ],
    [
        "17",
        "Confirmed",
        "Blue",
        "Green"
    ],
    [
        "18",
        "AA Cancelled",
        "Blue",
        "Gray"
    ],
    [
        "19",
        "Auto SMS",
        "White",
        "Red"
    ],
    [
        "20",
        "Searching Engineer",
        "Green",
        "White"
    ],
    [
        "21",
        "New Booking with Issues",
        "green",
        "white"
    ],
    [
        "22",
        "New Quote with Issues",
        "blue",
        "white"
    ],
    [
        "23",
        "Received Requisition",
        "green",
        "192,255,255"
    ],
    [
        "24",
        "ETQ Small Job Free Quote",
        "green",
        "white"
    ],
    [
        "25",
        "Cancellation Request",
        "red",
        "white"
    ],
    [
        "26",
        "Engineer To Quote",
        "Blue",
        "white"
    ],
    [
        "27",
        "No Charge Go Back",
        "green",
        "white"
    ],
    [
        "28",
        "RIGHTIO Call Me Back",
        "Blue",
        "White"
    ],
    [
        "29",
        "Debt Recovery",
        "Blue",
        "White"
    ],
    [
        "30",
        "Claim Validation",
        "Blue",
        "White"
    ],
    [
        "31",
        "Claim Cancelled",
        "Blue",
        "White"
    ],
    [
        "32",
        "Quote Extra Work Closed Down",
        "",
        ""
    ],
    [
        "33",
        "Pending Payment",
        "Green",
        "192,255,255"
    ],
    [
        "34",
        "Boiler Lead",
        "",
        ""
    ],
    [
        "35",
        "Lost Contact",
        "",
        ""
    ],
    [
        "36",
        "Cancellation Request",
        "",
        ""
    ],
    [
        "37",
        "Pulled for Parts - Parts Arrived",
        "",
        ""
    ],
    [
        "38",
        "Pre Allocated",
        "",
        ""
    ],
    [
        "39",
        "Payment Issue",
        "",
        ""
    ],
    [
        "40",
        "Pre Allocated Appt Verified",
        "",
        ""
    ],
    [
        "41",
        "Completed - Awaiting Payment",
        "",
        ""
    ],
    [
        "42",
        "Active Quote",
        "",
        ""
    ],
    [
        "43",
        "New Call Me Back",
        "",
        ""
    ],
    [
        "44",
        "Awaiting Authorisation",
        "",
        ""
    ],
    [
        "45",
        "Awaiting Contact from Customer",
        "",
        ""
    ],
    [
        "46",
        "Credit Control Chase Debt",
        "",
        ""
    ],
    [
        "47",
        "Credit Control Judgment Entered",
        "",
        ""
    ],
    [
        "48",
        "Auto Allocated",
        "",
        ""
    ],
    [
        "49",
        "Credit Control LBA First",
        "",
        ""
    ],
    [
        "50",
        "Credit Control Debt Complaint",
        "",
        ""
    ],
    [
        "51",
        "Credit Control Summons Issued",
        "",
        ""
    ],
    [
        "52",
        "Credit Control Legal",
        "",
        ""
    ],
    [
        "53",
        "Quote Site Visit Completed",
        "",
        ""
    ],
    [
        "54",
        "CCJ Enforcement",
        "",
        ""
    ],
    [
        "55",
        "Credit Control Arrangement to Pay",
        "",
        ""
    ],
    [
        "56",
        "Go Back Validation",
        "",
        ""
    ],
    [
        "57",
        "Pre-Alloc Next Job",
        "",
        ""
    ],
    [
        "58",
        "Deposit Refunded",
        "",
        ""
    ],
    [
        "59",
        "Failed CC Quote",
        "",
        ""
    ],
    [
        "60",
        "Failed Go Back",
        "",
        ""
    ],
    [
        "61",
        "Failed Upsell / Further Work",
        "",
        ""
    ],
    [
        "62",
        "Pulled for Parts - Pending Payment",
        "",
        ""
    ],
    [
        "63",
        "Job Escalation",
        "",
        ""
    ],
    [
        "64",
        "Credit Control LBA Final",
        "",
        ""
    ],
    [
        "65",
        "Cash / Cheque Review",
        "",
        ""
    ],
    [
        "66",
        "Invoice Review",
        "",
        ""
    ],
    [
        "96",
        "Technical or IT Issue",
        "",
        ""
    ],
    [
        "97",
        "Auto Offer",
        "",
        ""
    ],
    [
        "98",
        "Engineer On Route",
        "",
        ""
    ],
    [
        "99",
        "In Progress",
        "",
        ""
    ],
    [
        "100",
        "Pre Auto Offer",
        "",
        ""
    ],
    [
        "101",
        "Awaiting Customer Confirmation",
        "",
        ""
    ],
    [
        "110",
        "Completed - Chargeback",
        "",
        ""
    ],
]

// convert statuses to object, where id is key
const statuses: {
    [key: number]: {
        id: number,
        name: string,
        color: string,
        backgroundColor: string,
    }
} = {}
for (let i = 0; i < statusesArray.length; i++) {
    const status = statusesArray[i]
    statuses[Number(status[0])] = {
        id: Number(status[0]),
        name: status[1],
        color: status[2],
        backgroundColor: status[3]
    }
}

export default statuses